var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from "react";
import styled from "styled-components";
import { get } from 'lodash-es';
import { NextButton, PreviousButton } from "../doconButtons/doconButtons";
import ListItem from "./ListItem";
import { BaseBox, FlexBox } from '../../shared/Element';
var ListContainer = styled(BaseBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: white;\n  overflow: auto;\n  white-space: nowrap;\n  transition: all 1s;\n"], ["\n  background-color: white;\n  overflow: auto;\n  white-space: nowrap;\n  transition: all 1s;\n"])));
var Header = styled(FlexBox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  justify-content: space-between;\n  > * {\n    &:first-child { flex: 1; }\n  }\n"], ["\n  justify-content: space-between;\n  > * {\n    &:first-child { flex: 1; }\n  }\n"])));
var Root = styled(BaseBox)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  button { margin-top: 0; margin-bottom: 0; }\n"], ["\n  button { margin-top: 0; margin-bottom: 0; }\n"])));
function DoconListMenu(_a) {
    var title = _a.title, selected = _a.selected, _b = _a.lists, lists = _b === void 0 ? [] : _b, onChange = _a.onChange, props = __rest(_a, ["title", "selected", "lists", "onChange"]);
    var elementRef = useRef(null);
    var listContainer = elementRef.current;
    function handlePreviousButtonClick() {
        listContainer.scrollLeft -= 100;
    }
    function handleNextButtonClick() {
        listContainer.scrollLeft += 100;
    }
    function handleListItemClick(_a) {
        var index = _a.index, item = _a.item;
        var itemNode = get(elementRef, "current.children[" + index + "]");
        if (itemNode === null || itemNode === void 0 ? void 0 : itemNode.scrollIntoViewIfNeeded)
            itemNode === null || itemNode === void 0 ? void 0 : itemNode.scrollIntoViewIfNeeded({ behavior: 'smooth' });
        onChange && onChange({ index: index, item: item });
    }
    return (React.createElement(Root, __assign({}, props),
        React.createElement(Header, null,
            title,
            listContainer && listContainer.scrollWidth > listContainer.clientWidth &&
                React.createElement(FlexBox, null,
                    React.createElement(PreviousButton, { size: 'small', onClick: handlePreviousButtonClick }),
                    React.createElement(NextButton, { size: 'small', onClick: handleNextButtonClick }))),
        React.createElement(ListContainer, { ref: elementRef }, lists.map(function (i, index) { return (React.createElement(ListItem, { key: i.id || "listItem" + index, isSelected: i.value === selected || (!i.value && index === selected), index: index, item: i, onClick: handleListItemClick })); }))));
}
export default styled(DoconListMenu)(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
